import { useCallback, useEffect, useRef } from 'react';
import { useNotificationStore } from 'src/domain/stores/useNotificationStore';
import { openEventFromPush } from 'src/presentation/helpers/PushNavigationHelper';
import logError from 'src/data/services/logError';

/**
 * Central FCM notification-open routing for the event-deeplink (reminder) push (#349).
 */
export function usePushNavigation(): { onNavigationReady: () => void } {
	const coldStartHandled = useRef(false);

	useEffect(() => {
		const unsubscribe = useNotificationStore.getState().onNotificationOpened((message) => {
			openEventFromPush(message.data);
		});
		return unsubscribe;
	}, []);

	const onNavigationReady = useCallback((): void => {
		if (coldStartHandled.current) return;
		coldStartHandled.current = true;
		useNotificationStore
			.getState()
			.getInitialNotification()
			.then((message) => {
				if (message) openEventFromPush(message.data);
			})
			.catch(logError);
	}, []);

	return { onNavigationReady };
}
